// Builds an absolute URL for a stored media file. Plain <img src> requests
// are native browser fetches, not axios calls — they never picked up the
// REACT_APP_API_URL base axiosAuth.js sets for axios, so a bare
// relative path resolves against the frontend's own origin instead of the
// backend's once they're deployed as separate domains.
export function mediaFileUrl(mediaImageId) {
  return `${process.env.REACT_APP_API_URL || ''}/api/media-images/${mediaImageId}/file`;
}

// Small derivative (Platform Settings' Thumbnail Size) — every list/grid
// row showing a small image should use this instead of mediaFileUrl, so the
// browser downloads a few KB instead of the full original.
export function thumbFileUrl(mediaImageId) {
  return `${process.env.REACT_APP_API_URL || ''}/api/media-images/${mediaImageId}/thumb`;
}

// Medium derivative (Platform Settings' Preview Size) — the Product edit
// form's own image box and the Pricelist Extended (Catalog) Report.
export function previewFileUrl(mediaImageId) {
  return `${process.env.REACT_APP_API_URL || ''}/api/media-images/${mediaImageId}/preview`;
}
